import {
  HEX_18232F,
  HEX_212F41,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_66AAFF,
  HEX_959EB0,
  HEX_AB5DB0,
  HEX_E6444E,
  HEX_ECF4FF,
  HEX_F2F6FA,
  HEX_FB5C67,
  HEX_FCFDFE,
} from '@tanium/colors';
import { defineColor, ErrorFill as ErrorFillCommon, ThemeDefinition } from '@tanium/react-theme-definition';

export const DefaultBorderColor = defineColor([HEX_ECF4FF, HEX_18232F]);
export const DefaultFill = defineColor([HEX_F2F6FA, HEX_212F41]);
export const DefaultText = defineColor([HEX_3E4B68, HEX_959EB0]);
export const ErrorBorderColor = defineColor(['transparent', HEX_18232F]);
export const ErrorFill = ErrorFillCommon;
export const ErrorIconFill = defineColor([HEX_E6444E, HEX_FB5C67]);
export const ErrorText = defineColor([HEX_3E4B68, HEX_FCFDFE]);
export const InfoIconFill = defineColor([HEX_477FBA, HEX_66AAFF]);
export const LoadingBorderColor = defineColor([HEX_F2F6FA, HEX_18232F]);
export const LoadingFill = defineColor([HEX_FCFDFE, HEX_212F41]);
export const PendingIconFill: ThemeDefinition = () => HEX_AB5DB0;
